import { Routes } from "@angular/router";
import { autoLoginPartialRoutesGuard } from "angular-auth-oidc-client";

export const AppRoutes: Routes = [
  {
    path: "",
    canActivate: [autoLoginPartialRoutesGuard],
    loadChildren: () => import("./main/main.routes").then((m) => m.mainRoutes),
  },
  {
    path: "user",
    canActivate: [autoLoginPartialRoutesGuard],
    loadChildren: () => import("./user/user.routes").then((m) => m.userRoutes),
  },
  { path: "**", redirectTo: "" },
];
